export default {
  pt: {
    'portal.portalSolicitacoesPage.request': 'Solicitação',
    'portal.portalSolicitacoesPage.contract': 'Contrato',
    'portal.portalSolicitacoesPage.destination': 'Destino',
    'portal.portalSolicitacoesPage.loads': 'Cargas',
    'portal.portalSolicitacoesPage.desiredDate': 'Data desejada',
    'portal.portalSolicitacoesPage.priority': 'Prioridade',
    'portal.portalSolicitacoesPage.situation': 'Situação',
    'portal.portalSolicitacoesPage.title': 'Solicitações',
    'portal.portalSolicitacoesPage.eyebrow': 'Portal do cliente',
    'portal.portalSolicitacoesPage.subtitle': 'Seus pedidos de embarque e em que ponto do fluxo cada um está.',
    'portal.portalSolicitacoesPage.requestLoads': 'Solicitar cargas',
    'portal.portalSolicitacoesPage.list': 'Lista',
    'portal.portalSolicitacoesPage.loadFailed': 'Não foi possível carregar.',
    'portal.portalSolicitacoesPage.empty': 'Nenhuma solicitação ainda. Use “Solicitar cargas” para abrir o primeiro pedido.',
    'portal.portalSolicitacoesPage.kanban': 'Kanban',
    'portal.portalSolicitacoesPage.status.draft': 'Rascunho',
    'portal.portalSolicitacoesPage.status.submitted': 'Enviada',
    'portal.portalSolicitacoesPage.status.under_review': 'Em análise',
    'portal.portalSolicitacoesPage.status.approved': 'Aprovada',
    'portal.portalSolicitacoesPage.status.in_progress': 'Em execução',
    'portal.portalSolicitacoesPage.status.completed': 'Concluída',
    'portal.portalSolicitacoesPage.status.cancelled': 'Cancelada',
    'portal.portalSolicitacoesPage.priorityValue.low': 'Baixa',
    'portal.portalSolicitacoesPage.priorityValue.normal': 'Normal',
    'portal.portalSolicitacoesPage.priorityValue.high': 'Alta',
    'portal.portalSolicitacoesPage.priorityValue.urgent': 'Urgente',
  },
  en: {
    'portal.portalSolicitacoesPage.request': 'Request',
    'portal.portalSolicitacoesPage.contract': 'Contract',
    'portal.portalSolicitacoesPage.destination': 'Destination',
    'portal.portalSolicitacoesPage.loads': 'Loads',
    'portal.portalSolicitacoesPage.desiredDate': 'Desired date',
    'portal.portalSolicitacoesPage.priority': 'Priority',
    'portal.portalSolicitacoesPage.situation': 'Situation',
    'portal.portalSolicitacoesPage.title': 'Requests',
    'portal.portalSolicitacoesPage.eyebrow': 'Customer portal',
    'portal.portalSolicitacoesPage.subtitle': 'Your shipping requests and where each one is in the workflow.',
    'portal.portalSolicitacoesPage.requestLoads': 'Request loads',
    'portal.portalSolicitacoesPage.list': 'List',
    'portal.portalSolicitacoesPage.loadFailed': 'Could not load.',
    'portal.portalSolicitacoesPage.empty': 'No requests yet. Use “Request loads” to open the first request.',
    'portal.portalSolicitacoesPage.kanban': 'Kanban',
    'portal.portalSolicitacoesPage.status.draft': 'Draft',
    'portal.portalSolicitacoesPage.status.submitted': 'Submitted',
    'portal.portalSolicitacoesPage.status.under_review': 'Under review',
    'portal.portalSolicitacoesPage.status.approved': 'Approved',
    'portal.portalSolicitacoesPage.status.in_progress': 'In progress',
    'portal.portalSolicitacoesPage.status.completed': 'Completed',
    'portal.portalSolicitacoesPage.status.cancelled': 'Cancelled',
    'portal.portalSolicitacoesPage.priorityValue.low': 'Low',
    'portal.portalSolicitacoesPage.priorityValue.normal': 'Normal',
    'portal.portalSolicitacoesPage.priorityValue.high': 'High',
    'portal.portalSolicitacoesPage.priorityValue.urgent': 'Urgent',
  },
  es: {
    'portal.portalSolicitacoesPage.request': 'Solicitud',
    'portal.portalSolicitacoesPage.contract': 'Contrato',
    'portal.portalSolicitacoesPage.destination': 'Destino',
    'portal.portalSolicitacoesPage.loads': 'Cargas',
    'portal.portalSolicitacoesPage.desiredDate': 'Fecha deseada',
    'portal.portalSolicitacoesPage.priority': 'Prioridad',
    'portal.portalSolicitacoesPage.situation': 'Situación',
    'portal.portalSolicitacoesPage.title': 'Solicitudes',
    'portal.portalSolicitacoesPage.eyebrow': 'Portal del cliente',
    'portal.portalSolicitacoesPage.subtitle': 'Sus solicitudes de embarque y en qué punto del flujo se encuentra cada una.',
    'portal.portalSolicitacoesPage.requestLoads': 'Solicitar cargas',
    'portal.portalSolicitacoesPage.list': 'Lista',
    'portal.portalSolicitacoesPage.loadFailed': 'No se pudo cargar.',
    'portal.portalSolicitacoesPage.empty': 'Aún no hay solicitudes. Use “Solicitar cargas” para abrir la primera solicitud.',
    'portal.portalSolicitacoesPage.kanban': 'Kanban',
    'portal.portalSolicitacoesPage.status.draft': 'Borrador',
    'portal.portalSolicitacoesPage.status.submitted': 'Enviada',
    'portal.portalSolicitacoesPage.status.under_review': 'En análisis',
    'portal.portalSolicitacoesPage.status.approved': 'Aprobada',
    'portal.portalSolicitacoesPage.status.in_progress': 'En ejecución',
    'portal.portalSolicitacoesPage.status.completed': 'Completada',
    'portal.portalSolicitacoesPage.status.cancelled': 'Cancelada',
    'portal.portalSolicitacoesPage.priorityValue.low': 'Baja',
    'portal.portalSolicitacoesPage.priorityValue.normal': 'Normal',
    'portal.portalSolicitacoesPage.priorityValue.high': 'Alta',
    'portal.portalSolicitacoesPage.priorityValue.urgent': 'Urgente',
  },
}
